module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-padding-desktop",
    attrs: {
      "id": "arquivos"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar"
  }, [_vm._v(_vm._s(_vm.titulo))]), _c('p', [_vm._v("Aqui você encontrará os documentos para download")])], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('listagem', {
    attrs: {
      "itens": _vm.arquivos
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(arquivo) {
        return _c('arquivo', {
          attrs: {
            "arquivo": arquivo
          }
        })
      }
    }])
  })], 1), (_vm.naoTemDocumentos) ? _c('template', {
    slot: "feedback"
  }, [_c('mensagem', {
    staticClass: "-warn"
  }, [_c('p', [_vm._v("Nenhum documento foi encontrado no momento")])])], 1) : _vm._e(), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('back-and-share')], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdeaa022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Arquivos.vue
// module id = 527
// module chunks = 0